var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1Student(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 318,
    viewBox: "0 0 392 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.2596 89.188C126.548 68.6216 154.712 96.8063 227.168 54.2197C284.944 20.2633 326.997 52.4721 344.276 75.7282C352.527 86.8409 371.333 135.208 337.62 148.366C223.221 193.056 177.174 353.192 81.0924 263.178C42.1187 226.661 -31.3574 135.894 78.2596 89.188Z",
    fill: "#F0FDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 130,
    width: 292,
    height: 67,
    rx: 33.5,
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 127.5,
    width: 297,
    height: 72,
    rx: 36,
    stroke: "white",
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 136,
    width: 216,
    height: 55,
    rx: 27.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 136,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#1D254F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.51 173.63L294.41 164.53C293.863 163.983 293.863 163.097 294.41 162.55L296.39 160.57C296.937 160.023 297.823 160.023 298.37 160.57L304.5 166.7L317.63 153.57C318.177 153.023 319.063 153.023 319.61 153.57L321.59 155.55C322.137 156.097 322.137 156.983 321.59 157.53L305.49 173.63C304.943 174.177 304.057 174.177 303.51 173.63Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5727 174.554C81.6629 174.023 81.1321 173.341 80.9805 172.507C80.8668 171.635 81.1321 170.744 81.7766 169.834L83.3688 167.503L80.6962 167.674C79.5968 167.787 78.7059 167.579 78.0236 167.048C77.3412 166.517 77 165.721 77 164.66C77 163.598 77.3412 162.802 78.0236 162.271C78.7059 161.741 79.5968 161.513 80.6962 161.589L83.3688 161.817L81.8335 159.485C81.189 158.537 80.9236 157.647 81.0374 156.813C81.189 155.978 81.7387 155.277 82.6864 154.709C83.5962 154.178 84.4492 154.102 85.2453 154.481C86.0793 154.822 86.7048 155.524 87.1218 156.585L88.5434 159.769L89.9082 156.585C90.3252 155.524 90.9507 154.822 91.7847 154.481C92.6187 154.102 93.4906 154.197 94.4004 154.765C95.3861 155.334 95.9358 156.054 96.0495 156.926C96.1632 157.76 95.8979 158.632 95.2534 159.542L93.6612 161.817L96.3338 161.646C97.4711 161.532 98.362 161.741 99.0065 162.271C99.6888 162.802 100.03 163.598 100.03 164.66C100.03 165.721 99.6888 166.517 99.0065 167.048C98.362 167.579 97.4711 167.787 96.3338 167.674L93.6612 167.503L95.2534 169.834C95.8979 170.744 96.1632 171.616 96.0495 172.45C95.9358 173.284 95.3861 173.986 94.4004 174.554C93.4527 175.123 92.5808 175.237 91.7847 174.895C91.0265 174.554 90.42 173.853 89.965 172.791L88.5434 169.436L87.065 172.734C86.6101 173.796 85.9845 174.516 85.1884 174.895C84.3923 175.237 83.5204 175.123 82.5727 174.554Z",
    fill: "#1D254F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.506 174.554C107.596 174.023 107.065 173.341 106.914 172.507C106.8 171.635 107.065 170.744 107.71 169.834L109.302 167.503L106.629 167.674C105.53 167.787 104.639 167.579 103.957 167.048C103.274 166.517 102.933 165.721 102.933 164.66C102.933 163.598 103.274 162.802 103.957 162.271C104.639 161.741 105.53 161.513 106.629 161.589L109.302 161.817L107.767 159.485C107.122 158.537 106.857 157.647 106.971 156.813C107.122 155.978 107.672 155.277 108.62 154.709C109.529 154.178 110.382 154.102 111.179 154.481C112.013 154.822 112.638 155.524 113.055 156.585L114.477 159.769L115.841 156.585C116.258 155.524 116.884 154.822 117.718 154.481C118.552 154.102 119.424 154.197 120.334 154.765C121.319 155.334 121.869 156.054 121.983 156.926C122.096 157.76 121.831 158.632 121.187 159.542L119.594 161.817L122.267 161.646C123.404 161.532 124.295 161.741 124.94 162.271C125.622 162.802 125.963 163.598 125.963 164.66C125.963 165.721 125.622 166.517 124.94 167.048C124.295 167.579 123.404 167.787 122.267 167.674L119.594 167.503L121.187 169.834C121.831 170.744 122.096 171.616 121.983 172.45C121.869 173.284 121.319 173.986 120.334 174.554C119.386 175.123 118.514 175.237 117.718 174.895C116.96 174.554 116.353 173.853 115.898 172.791L114.477 169.436L112.998 172.734C112.543 173.796 111.918 174.516 111.122 174.895C110.326 175.237 109.454 175.123 108.506 174.554Z",
    fill: "#1D254F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.439 174.554C133.529 174.023 132.999 173.341 132.847 172.507C132.733 171.635 132.999 170.744 133.643 169.834L135.235 167.503L132.563 167.674C131.463 167.787 130.572 167.579 129.89 167.048C129.208 166.517 128.866 165.721 128.866 164.66C128.866 163.598 129.208 162.802 129.89 162.271C130.572 161.741 131.463 161.513 132.563 161.589L135.235 161.817L133.7 159.485C133.055 158.537 132.79 157.647 132.904 156.813C133.055 155.978 133.605 155.277 134.553 154.709C135.463 154.178 136.316 154.102 137.112 154.481C137.946 154.822 138.571 155.524 138.988 156.585L140.41 159.769L141.775 156.585C142.192 155.524 142.817 154.822 143.651 154.481C144.485 154.102 145.357 154.197 146.267 154.765C147.252 155.334 147.802 156.054 147.916 156.926C148.03 157.76 147.764 158.632 147.12 159.542L145.528 161.817L148.2 161.646C149.338 161.532 150.228 161.741 150.873 162.271C151.555 162.802 151.896 163.598 151.896 164.66C151.896 165.721 151.555 166.517 150.873 167.048C150.228 167.579 149.338 167.787 148.2 167.674L145.528 167.503L147.12 169.834C147.764 170.744 148.03 171.616 147.916 172.45C147.802 173.284 147.252 173.986 146.267 174.554C145.319 175.123 144.447 175.237 143.651 174.895C142.893 174.554 142.286 173.853 141.831 172.791L140.41 169.436L138.931 172.734C138.476 173.796 137.851 174.516 137.055 174.895C136.259 175.237 135.387 175.123 134.439 174.554Z",
    fill: "#1D254F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.372 174.554C159.462 174.023 158.932 173.341 158.78 172.507C158.666 171.635 158.932 170.744 159.576 169.834L161.168 167.503L158.496 167.674C157.396 167.787 156.506 167.579 155.823 167.048C155.141 166.517 154.8 165.721 154.8 164.66C154.8 163.598 155.141 162.802 155.823 162.271C156.506 161.741 157.396 161.513 158.496 161.589L161.168 161.817L159.633 159.485C158.989 158.537 158.723 157.647 158.837 156.813C158.989 155.978 159.538 155.277 160.486 154.709C161.396 154.178 162.249 154.102 163.045 154.481C163.879 154.822 164.504 155.524 164.921 156.585L166.343 159.769L167.708 156.585C168.125 155.524 168.75 154.822 169.584 154.481C170.418 154.102 171.29 154.197 172.2 154.765C173.186 155.334 173.735 156.054 173.849 156.926C173.963 157.76 173.697 158.632 173.053 159.542L171.461 161.817L174.133 161.646C175.271 161.532 176.162 161.741 176.806 162.271C177.488 162.802 177.83 163.598 177.83 164.66C177.83 165.721 177.488 166.517 176.806 167.048C176.162 167.579 175.271 167.787 174.133 167.674L171.461 167.503L173.053 169.834C173.697 170.744 173.963 171.616 173.849 172.45C173.735 173.284 173.186 173.986 172.2 174.554C171.252 175.123 170.38 175.237 169.584 174.895C168.826 174.554 168.22 173.853 167.765 172.791L166.343 169.436L164.865 172.734C164.41 173.796 163.784 174.516 162.988 174.895C162.192 175.237 161.32 175.123 160.372 174.554Z",
    fill: "#1D254F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.774 213.141H335.513L342.492 230.14C342.978 231.318 342.423 232.64 341.311 233.14L335.166 235.818C334.02 236.318 332.735 235.747 332.249 234.604L325.618 218.462L314.785 229.604C313.341 231.089 311 229.944 311 227.997V174.287C311 172.237 313.49 171.238 314.785 172.68L350.336 209.248C351.77 210.645 350.712 213.141 348.774 213.141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 30,
    y: 113,
    width: 334,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.145098 0 0 0 0 0.309804 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 43,
    y: 124,
    width: 248,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.145098 0 0 0 0 0.309804 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 264,
    y: 124,
    width: 87,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.145098 0 0 0 0 0.309804 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 295,
    y: 160,
    width: 72,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.145098 0 0 0 0 0.309804 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 197,
    y1: 130,
    x2: 197,
    y2: 197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Student);
export default __webpack_public_path__ + "static/media/step1_student.e783ecf7433b4de0ace83180f88af5b3.svg";
export { ForwardRef as ReactComponent };